export enum AnalysisType {
  AREA = "AREA",
  HISTORICAL = "HISTORICAL",
}

export enum AnalysisTypeTranslate {
  AREA = "Análise de área",
  HISTORICAL = "Análise histórica de safras",
}
